import axios from 'axios'
import { getBaseURLforBackEnd, getConfigAxios } from '@/utils.js'

const pending = new WeakMap()
function requestConfig(token) {
    const config = getConfigAxios()
    return { ...config, headers: { ...config.headers, Authorization: `Bearer ${token}` } }
}
function scope(context) {
    const token = localStorage.getItem('access_token')
    if (!token) return null
    if (context.state.sessionToken !== token) context.commit('resetCache', token)
    return token
}
export default {
    namespaced: true,
    state: { myTemplate: [], loaded: false, loading: false, error: '', details: {}, epoch: 0, sessionToken: null },
    mutations: {
        resetCache(state, token = null) {
            state.epoch++
            state.sessionToken = token
            state.myTemplate = []
            state.loaded = false
            state.loading = false
            state.error = ''
            state.details = {}
            pending.delete(state)
        },
        setMyTemplate(state, rows) { state.myTemplate = rows; state.loaded = true },
        setListStatus(state, { loading, error }) { state.loading = loading; state.error = error },
        setDetail(state, { id, data }) { state.details = { ...state.details, [id]: data } }
    },
    actions: {
        invalidate({ state, commit }) { commit('resetCache', state.sessionToken) },
        ensureList(context) {
            const token = scope(context)
            if (!token) return Promise.reject(new Error('Not signed in'))
            const { state, commit } = context
            if (state.loaded) return Promise.resolve(state.myTemplate)
            let jobs = pending.get(state)
            if (!jobs) { jobs = { details: {} }; pending.set(state, jobs) }
            if (jobs.list) return jobs.list
            const epoch = state.epoch
            const current = () => epoch === state.epoch && token === localStorage.getItem('access_token')
            commit('setListStatus', { loading: true, error: '' })
            jobs.list = axios.post(`${getBaseURLforBackEnd()}/api/listoflabnonautomate_templete_v2`, {}, requestConfig(token))
                .then(res => {
                    if (!current()) throw new Error('Session changed')
                    commit('setMyTemplate', res.data)
                    return res.data
                }).catch(error => {
                    if (current()) commit('setListStatus', { loading: false, error: 'โหลดรายชื่อ template ไม่สำเร็จ' })
                    throw error
                }).finally(() => {
                    if (current()) commit('setListStatus', { loading: false, error: state.error })
                    jobs.list = null
                })
            return jobs.list
        },
        ensureDetail(context, value) {
            const token = scope(context)
            if (!token) return Promise.reject(new Error('Not signed in'))
            const id = Number(value)
            if (!Number.isInteger(id) || id <= 0) return Promise.reject(new Error('Invalid template'))
            const { state, commit, dispatch } = context
            if (state.details[id]) return Promise.resolve(state.details[id])
            let jobs = pending.get(state)
            if (!jobs) { jobs = { details: {} }; pending.set(state, jobs) }
            if (jobs.details[id]) return jobs.details[id]
            const epoch = state.epoch
            jobs.details[id] = dispatch('ensureList').then(rows => {
                if (!rows.some(row => Number(row.id) === id)) throw new Error('Template not available')
                return axios.post(`${getBaseURLforBackEnd()}/api/getdatatemplatenonautomateid`, { id }, requestConfig(token))
            }).then(res => {
                if (epoch !== state.epoch || token !== localStorage.getItem('access_token')) throw new Error('Session changed')
                commit('setDetail', { id, data: res.data })
                return res.data
            }).finally(() => { delete jobs.details[id] })
            return jobs.details[id]
        }
    }
}
